module.exports = __webpack_public_path__ + "img/ic_chat_btn_channel.58617b09.svg";